/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRate.ts                          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/rate";

export class AutogenModelRate<RowType extends ModelRow> extends Endpoint<RowType, RowRateFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowRate extends ModelRow<RowRateFields> {
	constructor(values?: Partial<RowRateFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowRateFields {
	collection_method: string;
	commodity_id: string;
	company_id: string;
	confidence_level: number;
	contact_id: string;
	currency: string;
	customer_id: string;
	effective_date: Date;
	expected_close: Date;
	expiration_date: Date;
	friday: string;
	id: number;
	intrastate: string;
	is_opportunity: string;
	item: string;
	last_used_date: Date;
	mark_plan_id: string;
	min_weight_um: string;
	minimum_weight: number;
	minimum_weight_um: string;
	monday: string;
	opportunity_amt: number;
	opportunity_amt_c: string;
	opportunity_amt_d: Date;
	opportunity_amt_n: number;
	opportunity_amt_r: number;
	opportunity_name: string;
	opportunity_status: string;
	order_type: string;
	page_no: string;
	prepaid: string;
	primary_contact: string;
	remarks: string;
	revised: string;
	sales_status_id: string;
	salesperson_id: string;
	saturday: string;
	sunday: string;
	tariff: string;
	thursday: string;
	tiered_table: string;
	times_rate_used: number;
	tractor_type: string;
	trailer_type: string;
	truckload_ltl: string;
	tuesday: string;
	wednesday: string;
}

